import {BaseEnum, type EnumConstructor, makeEnum} from "../../../stem-core/state/BaseEnum";
import {Level, type LevelType} from "../../../stem-core/ui/Constants";
import {StoreObject} from "../../../stem-core/state/Store";
import {field} from "../../../stem-core/state/StoreField";
import {StemDate} from "../../../stem-core/time/Date";
import {Merchant} from "../MerchantStore";
import {UserProfile} from "../UserProfileStore";

@makeEnum
export class LoggingLevel extends BaseEnum {
    static DEBUG = 10;
    static INFO = 20;
    static WARNING = 30;
    static ERROR = 40;
    static CRITICAL = 50;
    static UNKNOWN;

    // Slightly different that the regular enum method
    static fromValue<T extends BaseEnum>(this: EnumConstructor<T>, value: number): T {
        for (const entry of this.all()) {
            // Left standing: UNKNOWN carries no value, so it holds the key while the rest hold numbers
            if (entry.value >= value) {
                return entry;
            }
        }
        return (this as any).UNKNOWN;
    }

    getLabelLevel(): LevelType {
        if (this.value >= LoggingLevel.ERROR.value) {
            return Level.ERROR;
        }
        if (this.value >= LoggingLevel.WARNING.value) {
            return Level.WARNING;
        }
        return Level.INFO
    }
}


export class BaseLogMessage extends StoreObject {
    @field(Date) createdAt: StemDate;
    @field(LoggingLevel) level: LoggingLevel;
    @field(Number) code: number;
    @field(String) message: string;
    @field(Object) extra: Record<string, any>;
    @field("Merchant") merchant: Merchant;
    @field("UserProfile") user: UserProfile;
}
